import GroupedReportView from '../../../components/reports/GroupedReportView';

export function TrialBalanceReport() {
  return (
    <GroupedReportView
      title="Trial Balance"
      description="Cumulative debit/credit balance of every account since ledger inception, as at a given date."
      endpoint="/reports/consolidated/trial-balance"
      filters={['asOfDate']}
      xlsx
    />
  );
}
